// Chakra imports
import {Portal, Box, useDisclosure} from '@chakra-ui/react';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import WhatsNewAnnouncements from 'components/whatsNew/WhatsNewAnnouncements';
import {SidebarContext} from 'contexts/SidebarContext';
import React, {useEffect, useState} from 'react';
import {matchPath, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import routes from 'routes.js';
import { useTranslation } from 'react-i18next';

// Custom Chakra theme
export default function Dashboard(props) {
    const {...rest} = props;

    const [fixed] = useState(false);
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(
        () => localStorage.getItem('sidebarCollapsed') === 'true'
    );
    const [bool, setBool] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();

    const getRouteLabel = route => (route.nameKey ? t(route.nameKey) : route.name);

    const toggleSidebarCollapsed = () => {
        setSidebarCollapsed((previous) => {
            localStorage.setItem('sidebarCollapsed', String(!previous));
            return !previous;
        });
    };

    useEffect(() => {
        setBool(!bool)
    }, [location]);

    const getRoute = () => {
        return window.location.pathname !== '/admin/full-screen-maps';
    };
    const routeMatchesLocation = (route) => {
        return !!matchPath(
            {path: `${route.layout}${route.path}`, end: true},
            location.pathname
        );
    };
    const getActiveRoute = (routes) => {
        let activeRoute = t('routes.mainDashboard');
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveRoute = getActiveRoute(routes[i].items);
                if (collapseActiveRoute !== activeRoute) {
                    return collapseActiveRoute;
                }
            } else if (routes[i].category) {
                let categoryActiveRoute = getActiveRoute(routes[i].items);
                if (categoryActiveRoute !== activeRoute) {
                    return categoryActiveRoute;
                }
            } else {
                if (routeMatchesLocation(routes[i])) {
                    return getRouteLabel(routes[i]);
                }
            }
        }
        return activeRoute;
    };
    const getActiveNavbar = (routes) => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveNavbar = getActiveNavbar(routes[i].items);
                if (collapseActiveNavbar !== activeNavbar) {
                    return collapseActiveNavbar;
                }
            } else if (routes[i].category) {
                let categoryActiveNavbar = getActiveNavbar(routes[i].items);
                if (categoryActiveNavbar !== activeNavbar) {
                    return categoryActiveNavbar;
                }
            } else {
                if (routeMatchesLocation(routes[i])) {
                    return routes[i].secondary;
                }
            }
        }
        return activeNavbar;
    };
    const getActiveNavbarText = (routes) => {
        let activeNavbar = false;
        for (let i = 0; i < routes.length; i++) {
            if (routes[i].collapse) {
                let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
                if (collapseActiveNavbar !== activeNavbar) {
                    return collapseActiveNavbar;
                }
            } else if (routes[i].category) {
                let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
                if (categoryActiveNavbar !== activeNavbar) {
                    return categoryActiveNavbar;
                }
            } else {
                if (routeMatchesLocation(routes[i])) {
                    return routes[i].messageNavbar;
                }
            }
        }
        return activeNavbar;
    };
    const getRoutes = (routes) => {
        return routes.map((route, key) => {
            if (route.layout === '/admin') {
                return (
                    <Route path={`${route.path}`} element={route.component} key={key}/>
                );
            }
            if (route.collapse) {
                return getRoutes(route.items);
            } else {
                return null;
            }
        });
    };
    document.documentElement.dir = 'ltr';
    const {onOpen} = useDisclosure();
    document.documentElement.dir = 'ltr';
    return (
        <Box>
            <Box>
                <SidebarContext.Provider
                    value={{
                        toggleSidebar,
                        setToggleSidebar,
                        sidebarCollapsed,
                        toggleSidebarCollapsed,
                    }}
                >
                    <Sidebar routes={routes} display="none" {...rest} />
                    <Box
                        float="right"
                        minHeight="100vh"
                        height="100%"
                        overflow="auto"
                        position="relative"
                        maxHeight="100%"
                        w={{base: '100%', xl: sidebarCollapsed ? 'calc( 100% - 80px )' : 'calc( 100% - 290px )'}}
                        maxWidth={{base: '100%', xl: sidebarCollapsed ? 'calc( 100% - 80px )' : 'calc( 100% - 290px )'}}
                        transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                        transitionDuration=".2s, .2s, .35s"
                        transitionProperty="top, bottom, width"
                        transitionTimingFunction="linear, linear, ease"
                    >
                        <Portal>
                            <Box>
                                <Navbar
                                    key={bool}
                                    onOpen={onOpen}
                                    logoText={'Horizon UI Dashboard PRO'}
                                    brandText={getActiveRoute(routes)}
                                    secondary={getActiveNavbar(routes)}
                                    message={getActiveNavbarText(routes)}
                                    fixed={fixed}
                                    {...rest}
                                />
                            </Box>
                        </Portal>

                        {getRoute() ? (
                            <Box
                                mx="auto"
                                p={{base: '20px', md: '30px'}}
                                pe="20px"
                                minH="100vh"
                                pt="50px"
                            >
                                <Routes>
                                    {getRoutes(routes)}
                                    <Route
                                        path="/"
                                        element={<Navigate to="/admin/default" replace/>}
                                    />
                                </Routes>
                                <WhatsNewAnnouncements />
                            </Box>
                        ) : null}
                    </Box>
                </SidebarContext.Provider>
            </Box>
        </Box>
    );
}
